export default __webpack_public_path__ + "static/media/Frida.3d555f1c.jpg";